export const colors = {
    base: {
        primary: "hsla(0, 0%, 3%, 1)",
        primaryInverse: "hsla(0, 0%, 100%, 1)",
        spaceGrey: "hsla(0, 0%, 20%)",
        autofill: "transparent",
    },
    action: {
        tertiary: "hsla(0, 0%, 100%, 0.1)",
    },
    text: {
        primary: "hsla(0, 0%, 100%, 1)",
        primaryInverse: "hsla(0, 0%, 100%, 1)",
        secondary: "hsla(207, 100%, 100%, 0.7)",
        secondaryInverse: "hsla(190, 3%, 34%, 0.6)",
        tertiary: "hsla(0, 0%, 100%, 0.4)",
        tertiaryInverse: "hsla(207, 14%, 9%, 0.22)",
    },
    line: {
        secondary: "hsla(0, 0%, 100%, 1)",
        primaryInverse: "hsla(207, 14%, 30%, 0.1)",
    },
};
